import React from 'react';
import {
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  ProductsScroll,
  TotalRow,
} from './InfoBoxV2.styles';

const DEFAULT_COLUMNS = ['Prodotto', 'Compagnia', 'Premio'];

// "Informazioni Prodotti" card shared by the purchase InfoBoxes. It only owns
// the look (card, scrolling table with sticky header, pinned Totale row): the
// rows are passed in as children and the total as a prop, so every InfoBox
// keeps its own row and total logic.
function ProductsTableCard({
  columns = DEFAULT_COLUMNS,
  total,
  className,
  children,
}) {
  return (
    <InfoCard className={className}>
      <InfoCardHeader>
        <InfoCardTitle>Informazioni Prodotti</InfoCardTitle>
      </InfoCardHeader>
      <ProductsScroll>
        <table>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column} scope="col">{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </ProductsScroll>
      <TotalRow>
        <span>Totale</span>
        <strong>
          &euro;
          {' '}
          {total}
        </strong>
      </TotalRow>
    </InfoCard>
  );
}

export default ProductsTableCard;
